import { BaseComponentProps } from '@/components/BaseComponentProps';
import { cva } from 'class-variance-authority';
import { AgnesBadge, cn } from '@agnes/ui';
import React from 'react';
import {
  CENTRAL_REPROCESSAMENTO_STATUS_NOMES,
  CentralReprocessamentoStatus,
} from '@/constants/central-reprocessamento/CentralReprocessamentoStatus';
import { Activity, Ban, Box, Check, Hourglass } from 'lucide-react';

export interface BadgeCentralReprocessamentoStatusProps extends BaseComponentProps {
  status: CentralReprocessamentoStatus;
  size?: 'sm' | 'md' | 'lg';
}

const badgeCVA = cva('whitespace-nowrap', {
  variants: {
    status: {
      CRIADO:
        'text-agnes-neutral bg-agnes-neutral/10 dark:text-agnes-neutral-light dark:bg-agnes-neutral/50',
      AGUARDANDO_SOLICITACAO:
        'text-agnes-warning bg-agnes-warning/10 dark:text-agnes-warning-light dark:bg-agnes-warning/50',
      AGUARDANDO_APROVACAO:
        'text-agnes-warning bg-agnes-warning/10 dark:text-agnes-warning-light dark:bg-agnes-warning/50',
      AGUARDANDO_EXECUCAO:
        'text-agnes-warning bg-agnes-warning/10 dark:text-agnes-warning-light dark:bg-agnes-warning/50',
      EM_ANDAMENTO:
        'text-agnes-info bg-agnes-info/10 dark:text-agnes-info-light dark:bg-agnes-info/50',
      FINALIZADO:
        'text-agnes-success bg-agnes-success/10 dark:text-agnes-success-light dark:bg-agnes-success/50',
      ERRO: 'text-agnes-error bg-agnes-error/10 dark:text-agnes-error-light dark:bg-agnes-error/50',
    },
  },
});

const iconCVA = cva('flex items-center justify-start gap-1 justify-self-start', {
  variants: {
    size: {
      sm: 'w-3 h-3',
      md: 'w-4 h-4',
      lg: 'w-6 h-6',
    },
  },
});

const iconMap: Partial<
  Record<CentralReprocessamentoStatus, React.ComponentType<{ className?: string }>>
> = {
  CRIADO: Box,
  AGUARDANDO_SOLICITACAO: Hourglass,
  AGUARDANDO_APROVACAO: Hourglass,
  AGUARDANDO_EXECUCAO: Hourglass,
  EM_ANDAMENTO: Activity,
  FINALIZADO: Check,
  ERRO: Ban,
};

export function BadgeCentralReprocessamentoStatus({
  className,
  status,
  size = 'md',
  dataQa,
  ...props
}: BadgeCentralReprocessamentoStatusProps) {
  const Icon = iconMap[status]!;
  return (
    <AgnesBadge
      className={cn(badgeCVA({ status }), className)}
      size={size}
      dataQa={dataQa}
      {...props}
    >
      <Icon className={cn(iconCVA({ size }))} />
      {CENTRAL_REPROCESSAMENTO_STATUS_NOMES[status]}
    </AgnesBadge>
  );
}
